// extracted by mini-css-extract-plugin
export default {"root":"e3Y82A","bg":"ob0DX2","arrow":"rvD3bK"};